import { Outlet } from 'react-router-dom'
import { SidebarNav } from './SidebarNav'

export function AppShell() {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      {/* Desktop sidebar - always visible */}
      <aside className="fixed inset-y-0 left-0 z-30 w-60 border-r bg-white">
        <SidebarNav />
      </aside>

      {/* Main content */}
      <main className="flex-1 pl-60">
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
